import { Fragment, JSX, useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronUp } from "react-feather";
import React from "react";
import "./styles.css";
import useOutsideClick from "../../hooks/useOutsideClick";
export interface dataTableProps<TData> {
    data: Array<TData & { id?: number }>;
    columns: dataColumn<TData>[];
    uniqueIdentifiyer: (items: TData) => string;
    onRowClick: (data: string, clickEVT: React.MouseEvent) => void;
    onRowDblClick?: (data: string) => void;
    selectedItem: string;
    getCustomClass?: (items: TData) => string;
    contextMenuOptions?: JSX.Element;
    contextMenuClick?: (val: string) => void;
}

export interface dataColumn<TData> {
    title: JSX.Element;
    toolTip?: string;
    getDataToolTip?: (data: TData) => string;
    key: string;
    getData: (data: TData) => {};
    width: string;
    minWidth: string;
    maxWidth?: string;
    canResize: boolean;
    sort:
        | {
              direction: "asc" | "desc" | undefined;
              sortMethod: Function;
              displayIcon: boolean;
          }
        | undefined;
    textAlignment: "left" | "center" | "right";
}

function DataTable<T>({
    data,
    columns,
    uniqueIdentifiyer,
    onRowClick,
    getCustomClass,
    onRowDblClick,
    selectedItem,
    contextMenuClick,
}: dataTableProps<T>) {
    const dataTable = useRef<HTMLTableElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const [showContactContext, setShowContactContext] = useState<{
        visible: boolean;
        val: string;
        x: number;
        y: number;
    }>({ visible: false, val: "", x: 0, y: 0 });
    useOutsideClick(menuRef, () => {
        setShowContactContext({ visible: false, val: "", x: 0, y: 0 });
    });
    data = JSON.parse(JSON.stringify(data));

    const handleMouseDown = (e: any) => {
        let currentIndicator = e.currentTarget as HTMLElement;
        let colselc = document.getElementById("resizeIndication") as HTMLElement;
        const headerCell = currentIndicator.parentElement?.parentElement;
        const nextCell: any = headerCell ? headerCell.nextSibling : null;

        if (!headerCell || !nextCell) return;

        headerCell.style.pointerEvents = "none";
        headerCell.style.userSelect = "none";
        const styles = window.getComputedStyle(headerCell);
        const startPos = {
            x: e.clientX,
            y: e.clientY,
            w: parseInt(styles.width, 10),
        };

        const resizeFunc = (evt: any) => {
            resizeCol({ resizeIndicator: colselc, startPos: startPos, elem: headerCell, mm: evt });
        };
        const mouseUpFunc = (evt: any) => {
            let currentCursorPosition = parseInt(colselc.style.left.replace("px", ""));

            if (currentCursorPosition < startPos.x) {
                let cellMinwidth = headerCell.style.minWidth
                    ? parseInt(headerCell?.style.minWidth.replace("px", ""))
                    : 0;
                let nextcellMaxwidth = nextCell?.style.maxWidth
                    ? parseInt(nextCell?.style.maxWidth.replace("px", ""))
                    : undefined;
                let currentCellStartWIdth = headerCell.clientWidth;
                let newWidth = Math.round(headerCell.clientWidth - (startPos.x - currentCursorPosition) + 0);
                let nextCellNewWidth = Math.round(nextCell.clientWidth + (startPos.x - currentCursorPosition) + 0);
                if (newWidth < cellMinwidth) {
                    newWidth = cellMinwidth;
                    nextCellNewWidth = Math.round(nextCell.clientWidth + (currentCellStartWIdth - cellMinwidth));
                }
                if (newWidth != headerCell.clientWidth) {
                    if (newWidth >= cellMinwidth) {
                        if (nextcellMaxwidth) {
                            if (nextCellNewWidth <= nextcellMaxwidth) {
                                headerCell.style.width = newWidth + "px";
                                nextCell.style.width = nextCellNewWidth + "px";
                            }
                        } else {
                            headerCell.style.width = newWidth + "px";
                            nextCell.style.width = nextCellNewWidth + "px";
                        }
                    }
                }
            } else {
                let cellMinwidth = nextCell?.style.minWidth ? parseInt(nextCell?.style.minWidth.replace("px", "")) : 0;
                let newWidth = Math.round(nextCell.clientWidth - (currentCursorPosition - startPos.x) + 0);
                let currentCellNewWidth = Math.round(headerCell.clientWidth + (currentCursorPosition - startPos.x) + 0);
                let currentCellMaxwidth = headerCell.style.maxWidth
                    ? parseInt(headerCell.style.maxWidth.replace("px", ""))
                    : undefined;

                if (newWidth >= cellMinwidth) {
                    if (currentCellMaxwidth) {
                        if (currentCellNewWidth <= currentCellMaxwidth) {
                            headerCell.style.width =
                                Math.round(headerCell.clientWidth + (currentCursorPosition - startPos.x) + 0) + "px";
                            nextCell.style.width =
                                Math.round(nextCell.clientWidth - (currentCursorPosition - startPos.x) + 0) + "px";
                        }
                    } else {
                        headerCell.style.width =
                            Math.round(headerCell.clientWidth + (currentCursorPosition - startPos.x) + 0) + "px";
                        nextCell.style.width =
                            Math.round(nextCell.clientWidth - (currentCursorPosition - startPos.x) + 0) + "px";
                    }
                } else {
                    headerCell.style.width = headerCell.clientWidth + (nextCell.clientWidth - cellMinwidth) + "px";
                    nextCell.style.width = cellMinwidth + "px";
                }
            }
            headerCell.style.pointerEvents = "auto";
            headerCell.style.userSelect = "auto";

            colselc.style.display = "none";
            document.removeEventListener("mousemove", resizeFunc, false);
            document.removeEventListener("mouseup", mouseUpFunc, false);
        };
        document.addEventListener("mousemove", resizeFunc, false);
        document.addEventListener("mouseup", mouseUpFunc, false);
    };
    function resizeCol(e: any) {
        const dx = e.mm.clientX - e.startPos.x;
        e.resizeIndicator.style.left = `${e.startPos.x + dx}` + "px";
        e.resizeIndicator.style.display = "block";
    }

    let clickCount = 0;

    const onClick = (evt: any, clickValue: string) => {
        clickCount++;

        if (clickCount == 1) {
            onRowClick(clickValue, evt);
        }

        setTimeout(async () => {
            if (clickCount > 1) {
                onRowDblClick ? onRowDblClick(clickValue) : onRowClick(clickValue, evt);
            }
            clickCount = 0;
        }, 300);
    };

    return (
        <>
            <div
                id="resizeIndication"
                className="selectResizer"
            ></div>
            {data.length > 0 && (
                <div
                    style={{ scrollPaddingTop: "30px", overflowY: "auto", width: "100%" }}
                    id="dataTableScrollDiv"
                >
                    <table
                        width="100%"
                        cellPadding={0}
                        cellSpacing={0}
                        ref={dataTable}
                        id="asdasdW"
                        className="gridTable"
                    >
                        <tr
                            className="tableHeader"
                            style={{ zIndex: "1500" }}
                        >
                            {columns.map((item, index) => {
                                let colWidths = {
                                    width: item.width,
                                    minWidth: item.minWidth,
                                    maxWidth: item.maxWidth ? item.maxWidth : "auto",
                                } as React.CSSProperties;
                                return (
                                    <th
                                        key={"headerKey_" + item.key ? item.key : index}
                                        id={"headerId_" + item.key ? item.key : index.toString()}
                                        style={colWidths}
                                        title={item.toolTip ? item.toolTip : ""}
                                    >
                                        <div className="headerDiv">
                                            <div
                                                onClick={
                                                    item.sort
                                                        ? () => {
                                                              item.sort!.sortMethod();
                                                          }
                                                        : undefined
                                                }
                                                style={{}}
                                                className={item.sort ? "headerSort" : ""}
                                            >
                                                <div style={{ padding: "4px", margin: "0px" }}>{item.title}</div>
                                                {item.sort && item.sort.displayIcon && item.sort.direction == "asc" ? (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "4px",
                                                            width: "10px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <ChevronUp></ChevronUp>
                                                    </div>
                                                ) : item.sort &&
                                                  item.sort.displayIcon &&
                                                  item.sort.direction == "desc" ? (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "4px",
                                                            width: "10px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <ChevronDown></ChevronDown>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            {columns.length - 1 > 1 && item.canResize && (
                                                <div
                                                    onMouseDown={handleMouseDown}
                                                    style={{
                                                        position: "absolute",
                                                        top: "1px",
                                                        right: "0px",
                                                        width: "5px",
                                                        zIndex: "1500",
                                                    }}
                                                >
                                                    &nbsp;
                                                </div>
                                            )}
                                        </div>
                                    </th>
                                );
                            })}
                        </tr>

                        {data.map((item, index) => {
                            const uniqVal = uniqueIdentifiyer(item);
                            let customClasses = getCustomClass ? getCustomClass(item) : "";
                            customClasses =
                                selectedItem == uniqVal
                                    ? customClasses + " gridRow selected"
                                    : customClasses + " gridRow";
                            return (
                                <Fragment key={"r" + uniqVal}>
                                    {" "}
                                    <tr
                                        key={"row_" + uniqVal}
                                        onClick={evt => {
                                            onClick(evt, uniqVal);
                                        }}
                                        id={"row_" + uniqVal}
                                        tabIndex={index}
                                        className={customClasses}
                                        onContextMenu={e => {
                                            if (contextMenuClick == undefined) return;
                                            e.preventDefault();
                                            setShowContactContext({
                                                visible: true,
                                                val: uniqVal,
                                                x: e.pageX,
                                                y: e.pageY,
                                            }); // return the unique val of the row that was clicked on
                                        }}
                                    >
                                        {columns.map((col, col_index) => {
                                            const colData = col.getData(item);
                                            return (
                                                <td
                                                    style={{ textAlign: col.textAlignment }}
                                                    key={col_index}
                                                    title={
                                                        col.getDataToolTip?.(item) ??
                                                        (typeof colData === "string" ? (colData as string) : "")
                                                    }
                                                >
                                                    {colData}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </table>
                    {showContactContext.visible && (
                        <div
                            style={{
                                top: showContactContext.y + "px",
                                left: showContactContext.x + "px",
                                position: "fixed",
                                float: "left",
                                zIndex: "50",
                            }}
                            ref={menuRef}
                        >
                            <ul className="contextMenuUl">
                                <li
                                    onClick={() => {
                                        if (contextMenuClick) {
                                            setShowContactContext({ visible: false, val: "", x: 0, y: 0 });
                                            contextMenuClick(showContactContext.val);
                                        }
                                    }}
                                >
                                    Duplicate Template
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}
export default DataTable;
